export function checkSafari() {
  return /safari/i.test(window.navigator.userAgent.toLowerCase());
}

export const checkIOSAgent = () => {
  return /(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent);
};
export const checkWeChatAgent = () => {
  return /MicroMessenger/i.test(window.navigator.userAgent);
};
export const checkMobileAgent = () => {
  return /(iPhone|iPad|iPod|iOS|Android|WebOS|BlackBerry|Windows Phone)/i.test(
    window.navigator.userAgent
  );
};
export const checkAliPay = () => {
  return /AlipayClient/i.test(window.navigator.userAgent);
};

export const checkMacAgent = () => {
  return /(Mac|OS)/i.test(window.navigator.userAgent);
};
